import { ICompanyRequest } from '../interfaces/requests';

export const COMPANY_REQUESTS_MOCK: ICompanyRequest[] = [
  {
    id: 'KfSJZtEclM19CD1',
    agreementName: 'BRFALABELLABRFALABELLA',
    type: 'SUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Rafael Rojas',
    state: 'in_progress',
    hasAttachments: true,
    message: {}
  },
  {
    id: 'KfSJZtEclM19CD2',
    agreementName: 'BRFALABELLA',
    type: 'SUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Rafael Rojas',
    state: 'approved',
    hasAttachments: false,
    message: {
      seen: false
    }
  },
  {
    id: 'KfSJZtEclM19CD3',
    agreementName: 'BRFALABELLA',
    type: 'SUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Alicia Cortez',
    state: 'rejected',
    hasAttachments: true,
    message: {
      seen: false,
      status: 'unknown_error'
    }
  },
  {
    id: 'KfSJZtEclM19CD4',
    agreementName: 'BRFALABELLA',
    type: 'UNSUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Valentina Perez',
    state: 'approved',
    hasAttachments: true,
    message: {
      seen: true
    }
  },
  {
    id: 'KfSJZtEclM19CD5',
    agreementName: 'BRFALABELLA',
    type: 'SUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Rafael Rojas',
    state: 'approved',
    hasAttachments: false,
    message: {
      seen: true
    }
  },
  {
    id: 'KfSJZtEclM19CD6',
    agreementName: '',
    type: 'UNSUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Alicia Cortez',
    state: 'rejected',
    hasAttachments: true,
    message: {
      seen: false,
      status: 'unknown_error'
    }
  },
  {
    id: 'KfSJZtEclM19CD7',
    agreementName: '',
    type: 'SUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Valentina Perez',
    state: 'rejected',
    hasAttachments: true,
    message: {
      seen: false,
      status: 'validation_error'
    }
  },
  {
    id: 'KfSJZtEclM19CD8',
    agreementName: '',
    type: 'UNSUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Valentina Perez',
    state: 'rejected',
    hasAttachments: true,
    message: {
      seen: false,
      status: 'validation_error'
    }
  },
  {
    id: 'KfSJZtEclM19CD9',
    agreementName: 'BRFALABELLABRFALABELLA',
    type: 'SUBSCRIBE',
    creationDate: '11/11/2022 17:00',
    requester: 'Rafael Rojas',
    state: 'partially_approved',
    hasAttachments: true,
    message: {}
  }
];

export const COMPANY_REQUEST_RESPONSE_MOCK = {
  data: {
    requests: COMPANY_REQUESTS_MOCK
  }
};

export const INCOMPLETE_SUBSCRIBE_REQUEST = {
  successAmount: 5,
  errorAmount: 2,
  collaborators: [
    {
      documentValue: { error: 'error', value: '1111111-1' },
      firstLastName: { value: 'Barone' },
      secondLastName: { error: 'error', value: 'secondLastName' },
      name: { error: 'error', value: 'Alejandro' },
      email: { error: 'error', value: 'test@domain.cl' },
      birthDate: { error: 'error', value: '12/31/23' },
      gender: { value: 'm' }
    },
    {
      documentValue: { value: '1111111-2', error: 'error' },
      firstLastName: { value: 'Barone2', error: 'error' },
      secondLastName: { value: 'secondLastName' },
      name: { value: 'Alejandro' },
      email: { value: 'test@domain.cl' },
      birthDate: { value: '12/31/23' },
      gender: { value: 'm', error: 'error' }
    }
  ]
};

export const COMPANY_REQUEST_DETAIL_MOCK = {
  id: 'KfSJZtEclM19CD',
  agreementName: '',
  type: 'UNSUBSCRIBE',
  creationDate: '11/11/2022 17:00',
  requester: 'Valentina Perez',
  state: 'rejected',
  hasAttachments: true,
  message: {
    seen: false,
    status: 'validation_error',
    error: INCOMPLETE_SUBSCRIBE_REQUEST
  }
};
